import {
  TableRow,
  TableCell,
  StatusIndicator,
  StatusText,
} from "styles/devices/deviceDetails.styles";
import { ParamSetPointCell } from "./params/ParamSetPointCell";
import { ParamConnectionSlot } from "styles/devices/deviceTable.styles";

interface ConfigurableStatusRowProps {
  name: string;
  currentValue: number | string | null;
  setPoint: number | string;
  isConfigured: boolean;
  isEditing: boolean;
  pendingValue: number;
  min: number;
  max: number;
  step: number;
  suffix?: string;
  alwaysActive?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  onValueChange: (value: number) => void;
}

function ConfigurableStatusRow({
  name,
  currentValue,
  setPoint,
  isConfigured,
  isEditing,
  pendingValue,
  min,
  max,
  step,
  suffix = "",
  alwaysActive = false,
  disabled = false,
  disabledMessage = "",
  onValueChange,
}: ConfigurableStatusRowProps) {
  const slug = name.toLowerCase().replace(/\s+/g, "-");
  const formattedCurrentValue = currentValue === -9999 ? "X" : currentValue;
  const connected = isConfigured || alwaysActive;

  return (
    <TableRow connected={connected}>
      <TableCell>
        <strong>{name}</strong>
      </TableCell>
      <TableCell>{formattedCurrentValue}</TableCell>
      <TableCell>
        <ParamSetPointCell
          value={setPoint}
          pendingValue={pendingValue}
          isEditing={isEditing}
          min={min}
          max={max}
          step={step}
          suffix={suffix}
          disabled={disabled}
          disabledMessage={disabledMessage}
          inputId={`${slug}-setpoint`}
          onValueChange={onValueChange}
        />
      </TableCell>
      <TableCell>
        <ParamConnectionSlot>
          <StatusIndicator connected={connected} />
          <StatusText connected={connected}>
            {alwaysActive ? "N/A" : isConfigured ? "Configured" : "Not Configured"}
          </StatusText>
        </ParamConnectionSlot>
      </TableCell>
    </TableRow>
  );
}

export default ConfigurableStatusRow;
